/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import action from '../../../action';
import Validator from '../../../utils/formValidator';
import { ReactComponent as PasswordShow } from '../../../assets/icons/showPassword.svg';
import { ReactComponent as PasswordHide } from '../../../assets/icons/hidePassword.svg';
import axios from 'axios';
import Cookies from 'js-cookie';
import rules from '../../../constants/rules';
import { api_config } from '../../../constants/api';
import Utils from '../../../utils/utils';

export default function SignUpEmail(props) {
  //step ==2
  let timer;
  const lang = Utils.getLanguage();
  console.log('lag', lang);
  const [loading, setLoading] = useState(false);
  const reducerData = useSelector((state) => state.userinfo);
  const [time, setTime] = useState(0);
  const { t } = useTranslation(['userLoginTips']);
  let second = 0;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const passWordIconRender = (visible) => {
    return visible ? <PasswordShow /> : <PasswordHide />;
  };

  const getCode = () => {
    let email = form.getFieldValue('email');
    //获取验证码
    let checkEmail = rules.email.test(email);
    if (checkEmail) {
      let formData = new FormData();
      formData.append('email', email);
      axios({
        method: 'POST',
        url: api_config.API_V2_URL + 'accounts/verification-code',
        data: formData,
      })
        .then((obj) => {
          let res = obj.data;
          if (res.code === 200) {
            localStorage.setItem('signUpTime', new Date().getTime().toString());
            // message.success(t("Ithasbeensenttoyourmailboxpleasecheckit"));
            localStorage.setItem('userResetEmail', email); //保存用户email
            localStorage.setItem('emailToken', res.data.token); //保存用户的验证码token
            waitTime();
            dispatch(action.sendVerification(res.data));
          }
        })
        .catch((err) => {
          let res = err.response;
          if (res.status === 500) {
            message.error(t('500'));
          } else {
            switch (res.data.code) {
              case 404001:
                message.error(t('NoaccountfoundwiththatEmailaddress'));
                break;
              case 400104:
                message.error(
                  t('ThisEmailhasbeenregisteredpleasechooseanother')
                );
                break;
              default:
                message.error(t('500'));
            }
          }
        });
    }
  };
  const renderGetCodeBtn = () => {
    return time === 0 ? (
      <span onClick={() => getCode()}>{t('GetCode')}</span>
    ) : (
      <span style={{ cursor: 'not-allowed' }}>{time}s</span>
    );
  };
  const waitTime = () => {
    let sendTime = localStorage.getItem('signUpTime');
    if (sendTime == null) {
      clearInterval(timer);
    } else {
      timer = setInterval(() => {
        if (second < 0) {
          localStorage.removeItem('signUpTime');
          clearTimeout(timer);
          second = 0;
          setTime(second);
        } else {
          second = (
            60 -
            (new Date().getTime() - parseInt(sendTime)) / 1000
          ).toFixed(0);
          setTime(second);
        }
      }, 1000);
    }
  };
  const changeIntoLogin = () => {
    //跳转登录表单
    props.changeStep(2);
  };

  const loginRequest = (formData) => {
    localStorage.setItem('isFirstLogin', '1');
    axios({
      method: 'post',
      url: api_config.API_V2_URL + 'sessions',
      data: formData,
    })
      .then((obj) => {
        let res = obj.data;
        if (res.code === 200) {
          message.success(t('Loginsuccessful'));
          localStorage.removeItem('defeatCount');
          Cookies.set('authorization', res.data.authorization, { expires: 30 });
          let hostName = window.location.hostname;
          Cookies.set('access_token', res.data.account_access_token, {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          let expires_in = new Date().getTime() + 30 * 86400 * 1000;
          Cookies.set('access_token_expires_in', expires_in.toString(), {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          dispatch(action.loginIn(res.data));
          dispatch(
            action.onSignUpModal({
              visible: false,
            })
          );
          dispatch(
            action.isLogin({
              value: true,
            })
          );
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 500) {
          message.error(t('500'));
        } else {
          switch (res.data.code) {
            case 400101:
              message.error(t('NoaccountfoundwiththatEmailaddress'));
              break;
            case 400205:
              message.error(t('YourpasswordwasincorrectPleasetryagain'));
              break;
            default:
              message.error(t('500'));
          }
        }
      });
  };

  const onSubmit = (value) => {
    setLoading(true);
    console.log('value', value);
    const { email, verificationCode, password, confirmPassword } = value;
    let formData = new FormData();
    formData.append('email', email);
    formData.append('code', verificationCode);
    formData.append(
      'token',
      reducerData.emailToken.token || localStorage.getItem('emailToken')
    );
    formData.append('password', password);
    formData.append('confirm_password', confirmPassword);

    axios({
      method: 'POST',
      url: api_config.API_V2_URL + 'register',
      data: formData,
    })
      .then((obj) => {
        let res = obj.data;
        if (res.code === 200) {
          message.success(res.message, 1);
          dispatch(action.signUpEmail(res.data));
          let data = new FormData();
          data.append('email', email);
          data.append('password', password);
          loginRequest(data);
          dispatch(
            action.onSignUpModal({
              visible: false,
            })
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        let res = err.response;
        switch (res.data.code) {
          case 400224:
            message.error(t('reg400224'));
            break;
          case 400223:
            message.error(t('reg400223'));
            break;
          case 400301:
            message.error(
              t('Invalidverificationcodepleasereenterthecorrectone')
            );
            break;
          default:
            message.error(t('500'));
        }
        setLoading(false);
        // message.error(err.response.data.msg, 1);
      });
  };

  useEffect(() => {
    waitTime();
    return () => {
      clearInterval(timer);
    };
  }, []);
  return (
    <div className='signUpEmail'>
      <div>
        <div className='loginTitle'>{t('SignUpwithemail')}</div>
        <div className='loginSubTitle'>
          {t('Alreadyhaveaccount')}&nbsp;
          <span onClick={changeIntoLogin} className='signUpLink'>
            {t('Login')}
          </span>
        </div>
        <div>
          <Form form={form} onFinish={onSubmit}>
            <Form.Item
              className='formItem'
              validateTrigger='onBlur'
              name='email'
              rules={[
                {
                  required: true,
                  validator: Validator.emailValidator,
                },
              ]}
              getValueFromEvent={(e) => {
                return e.target.value.replace(/\s+/g, '');
              }}
            >
              <Input placeholder={t('Email')} className='inputForm' />
            </Form.Item>
            <Form.Item
              className='formItem'
              name='verificationCode'
              validateTrigger='onBlur'
              getValueFromEvent={(e) => {
                return e.target.value.replace(/\s+/g, '');
              }}
              rules={[
                {
                  required: true,
                  validator: Validator.emptyValidator,
                },
              ]}
            >
              <Input
                addonAfter={renderGetCodeBtn()}
                className={
                  lang === 'ar' ? 'verificationInputAr' : 'verificationInput'
                }
                placeholder={t('Verificationcode')}
              />
            </Form.Item>
            <Form.Item
              className='formItem'
              name='password'
              validateTrigger='onBlur'
              getValueFromEvent={(e) => {
                return e.target.value.replace(/\s+/g, '');
              }}
              rules={[
                {
                  required: true,
                  validator: Validator.passwordValidator,
                },
              ]}
            >
              <Input.Password
                iconRender={passWordIconRender}
                placeholder={t('Password')}
                type='password'
                className='inputForm'
              />
            </Form.Item>
            <Form.Item
              className='formItem'
              validateTrigger='onBlur'
              getValueFromEvent={(e) => {
                return e.target.value.replace(/\s+/g, '');
              }}
              rules={[
                {
                  required: true,
                  validator: (rule, value) =>
                    Validator.passwordSameValidator(
                      rule,
                      value,
                      form.getFieldValue('password')
                    ),
                },
              ]}
              name='confirmPassword'
            >
              <Input.Password
                iconRender={passWordIconRender}
                placeholder={t('ConfirmPassword')}
                type='password'
                className='inputForm'
              />
            </Form.Item>
            <Form.Item className='loginFormItem'>
              <Button
                loading={loading}
                className='loginBtn'
                type='primary'
                htmlType='submit'
              >
                {t('Notaregistereduseryet2')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}
